import { render } from "./InformationPage.vue?vue&type=template&id=16528967&scoped=true"
import script from "./InformationPage.vue?vue&type=script&lang=js"
export * from "./InformationPage.vue?vue&type=script&lang=js"

import "./InformationPage.vue?vue&type=style&index=0&id=16528967&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16528967"]])

export default __exports__